export const tableConfig = [
  {
    name: "cabang",
    label: "\n",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          width: "200px",
          minWidth: "200px",
          textAlign: "center",
        },
      }),
    },
  },
  {
    name: "q1y2",
    label: "Q1 Y-2",
    options: { sort: false },
  },
  {
    name: "q2y2",
    label: "Q2 Y-2",
    options: { sort: false },
  },
  {
    name: "q3y2",
    label: "Q3 Y-2",
    options: { sort: false },
  },
  {
    name: "q4y2",
    label: "Q4 Y-2",
    options: { sort: false },
  },
  {
    name: "q1y1",
    label: "Q1 Y-1",
    options: { sort: false },
  },
  {
    name: "q2y1",
    label: "Q2 Y-1",
    options: { sort: false },
  },
  {
    name: "q3y1",
    label: "Q3 Y-1",
    options: { sort: false },
  },
  {
    name: "q4y1",
    label: "Q4 Y-1",
    options: { sort: false },
  },
  {
    name: "q1y",
    label: "Q1 Y",
    options: { sort: false },
  },
  {
    name: "q2y",
    label: "Q2 Y",
    options: { sort: false },
  },
  {
    name: "q3y",
    label: "Q3 Y",
    options: { sort: false },
  },
  {
    name: "q4y",
    label: "Q4 Y",
    options: { sort: false },
  },
];

export const transformResponseLastThreeYearsToTable = (val = []) => {
  if (!Array.isArray(val)) return [];

  return val.map((item, index) => ({
    no: index + 1,
    cabang: item.kodeCabang,
    q1y2: item.y2q1,
    q2y2: item.y2q2,
    q3y2: item.y2q3,
    q4y2: item.y2q4,
    q1y1: item.y1q1,
    q2y1: item.y1q2,
    q3y1: item.y1q3,
    q4y1: item.y1q4,
    q1y: item.yq1,
    q2y: item.yq2,
    q3y: item.yq3,
    q4y: item.yq4,
  }));
};
